import { useState } from "react";
import { X } from "lucide-react";

// Props:
//   post: the post being edited (must have text + id)
//   onClose: () => void
//   onSave: (newText: string) => Promise<void>
function PostEditModal({ post, onClose, onSave }) {
  const [text, setText] = useState(post?.text || "");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    const trimmed = text.trim();
    if (!trimmed || saving) return;
    setSaving(true);
    try {
      await onSave(trimmed);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
          <h3 className="text-[15px] font-semibold text-slate-900">
            Edit post
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded hover:bg-gray-100 text-gray-500"
          >
            <X size={18} />
          </button>
        </div>
        <div className="px-5 py-4">
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={5}
            className="w-full resize-y border border-gray-200 rounded-md px-3 py-2 text-[13.5px] text-slate-800 placeholder-gray-400 focus:outline-none focus:border-slate-400"
          />
        </div>
        <div className="flex justify-end gap-2 px-5 py-3 bg-gray-50 rounded-b-xl border-t border-gray-200">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-1.5 text-[12.5px] font-semibold text-gray-700 border border-gray-300 rounded-md hover:bg-white"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            disabled={!text.trim() || saving}
            className="px-4 py-1.5 text-[12.5px] font-semibold text-white bg-slate-900 hover:bg-slate-800 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PostEditModal;
